import React from "react";
import "./GrowbooPage.css"; // Make sure to create this CSS file
import GrowbooImage from "../../../../assets/frontpage/growboo/about-us1.png"; // Update the path as necessary

const GrowbooPage = () => {
  return (
    <div className="growboo-container">
      <div className="growboo-content">
        <h1 className="growboo-title">The Grow Bizint International</h1>
        <p className="growboo-description">
          Welcome to Grow Bizint International, where we turn financial dreams into
          reality. Our mission is simple yet powerful: to make investing
          accessible, secure, and rewarding for everyone. Whether you're just
          starting your investment journey or looking for a reliable platform to
          maximize your returns, Grow Bizint International is here to guide you
          every step of the way.
        </p>
        <button className="learn-more-button">
          Learn more <span className="arrow">↗</span>
        </button>
      </div>
      <div className="growboo-image-placeholder">
        <img src={GrowbooImage} className="growboo-image" alt="Team working" />
      </div>
    </div>
  );
};

export default GrowbooPage;
